import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs-compat/Observable'
import { OrderApiConfiguration } from '../../order-and-billing/order-api-configuration';
import { ServiceBase } from '../../../infrastructure/serviceBase.component';
import { PatientEncounterInsuranceViewModel } from 'app/shared/models/orders-and-billing/patient-encounter-insurance-view-model';

@Injectable()
export class PatientEncounterInsuranceService extends ServiceBase {

    private actionUrl: string;
    private url: string;
    private _getByFillter: string;
    private _getByEncounter: string;
    private _getByEncounterIds: string;
    private _getInPatientAccommodationClass: string;

    constructor(private _http: HttpClient, private _configuration: OrderApiConfiguration) {
        super();
        this.actionUrl = _configuration.server;
        this.url = this.actionUrl + _configuration.patientEncounterInsurance.url;
        this._getByFillter = this.actionUrl + _configuration.patientEncounterInsurance.getByFilter;
        this._getByEncounter = this.actionUrl + _configuration.patientEncounterInsurance.getByEncounter;
        this._getByEncounterIds = this.actionUrl + _configuration.patientEncounterInsurance.getByEncounterIds;
        this._getInPatientAccommodationClass = this.actionUrl + _configuration.patientEncounterInsurance.getInPatientAccommodationClass;
    }

    public get = (): Observable<any> => {
        return this._http.get<any>(this.url);
    }

    public getByFilter = (patientId, encounterId, payerId, PatientType): Observable<any> => {
        const query = `?patientId=${patientId}&&encounterId=${encounterId}&&payerId=${payerId}
        &&patientType=${PatientType}`;
        return this._http.get<any>(this._getByFillter + query);
    }

    public getByEncounter = (encountersId, patientTypeId): Observable<PatientEncounterInsuranceViewModel[]> => {
        const query = `?encountersId=${encountersId}&&patientTypeId=${patientTypeId}`;
        return this._http.get<any>(this._getByEncounter + query);
    }

    public getOutPatientEncounterInsuranceByEncounterId = (encountersIds): Observable<PatientEncounterInsuranceViewModel[]> => {
        const query = `?encounterIds=${encountersIds}`;
        return this._http.get<any>(this._getByEncounterIds + query);
    }

    public getInPatientAccommodationClass = (patientId: number, encounterId: number, patientType: number): Observable<any[]> => {
        const query = `?patientId=${patientId}&&encounterId=${encounterId}&&patientType=${patientType}`;
        return this._http.get<any>(this._getInPatientAccommodationClass + query);
    }
}
